module.exports = __webpack_public_path__ + "static/media/2.3ae5174a.jpg";